// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: grid;
  /* Make left and right columns auto-sized and the middle flexible so left
    content can grow dynamically when present. */
  grid-template-columns: auto 1fr auto;
  grid-auto-rows: 1;
  align-items: center;
  padding: 30px 0;
  padding: 30px var(--layout-research-padding, 0);
  box-shadow: 0 0px 6px 1px rgba(0, 0, 0, 0.22);
  z-index: 100;
  position: relative;
}
@media (max-width: 768px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    padding: 15px 10px;
    padding: 15px var(--layout-research-padding, 10px);
    box-shadow: 0 0px 6px 1px rgba(0, 0, 0, 0.22);
  }
  .navbar[data-has-logo=false] {
    grid-template-columns: 1fr auto;
  }
}
@media (max-width: 576px) {
  .navbar {
    padding: 12px 8px 12px 10px;
  }
}
@media (min-width: 768px) {
  .navbar {
    grid-template-columns: auto 1fr;
    padding: 15px 10px;
    padding: 15px var(--layout-research-padding, 10px);
  }
  .navbar[data-has-logo=false] {
    grid-template-columns: 1fr;
  }
}
@media (min-width: 992px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    padding: 15px 10px;
    padding: 15px var(--layout-research-padding, 10px);
  }
  .navbar[data-has-logo=false] {
    grid-template-columns: 1fr auto;
  }
}
@media (min-width: 1200px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    box-shadow: none;
  }
  .navbar[data-has-logo=false] {
    grid-template-columns: 1fr auto;
  }
}
.navbar[data-theme=transparent] {
  background-color: transparent;
}
.navbar[data-theme=light] {
  background-color: var(--primary-color-light-500);
}
.navbar * + * {
  margin-top: 0;
}
.navbar__brand {
  visibility: hidden;
  grid-row: 1;
  display: flex;
  align-items: center;
}
@media (max-width: 1200px) {
  .navbar__brand {
    visibility: visible;
    padding-left: 2px;
  }
}
@media (max-width: 576px) {
  .navbar__brand {
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar__brand[data-desktop=true] {
    visibility: hidden;
    padding-left: 0px;
  }
}
.navbar__brand__button {
  margin-right: 15px;
}
.navbar__brand__logo {
  width: 50px;
  margin-top: 5px;
}
.navbar__brand__logo a {
  border: 0;
}
.navbar__brand.hold {
  visibility: visible;
  padding-left: 30px;
}
.navbar__body {
  grid-row: 1;
  display: grid;
  /* inside the body, make left and right auto and middle flexible */
  grid-template-columns: auto 1fr auto;
  grid-auto-rows: 1;
}
.navbar__body:before {
  content: none;
}
.navbar__body:after {
  content: none;
}
.navbar__end {
  grid-row: 1;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}
@media (max-width: 992px) {
  .navbar__end {
    display: flex !important;
    visibility: visible !important;
    margin-left: 8px;
    flex-shrink: 0;
    min-width: auto;
  }
}
@media (max-width: 576px) {
  .navbar__end {
    margin-left: 2px;
    padding-right: 2px;
  }
}
.navbar__end__button, .navbar__end__button:visited {
  display: inline-flex;
  padding: 8px 14px;
  border-radius: 5px;
  background-color: var(--primary-color-500);
  color: var(--primary-color-light-500);
  font-family: "Aller";
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 15px;
  border-bottom: 0;
  transition: 0.3s;
}
.navbar__end__button:hover {
  transition: 0.3s;
  color: var(--primary-color-light-500);
  border-bottom: 0;
  box-shadow: 0;
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/Navigations/NavBar/NavBar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA;gDAAA;EAEA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EAAA,+CAAA;EAEA,6CAAA;EACA,YAAA;EACA,kBAAA;AAAF;AAEE;EAbF;IAcI,oCAAA;IACA,kBAAA;IAAA,kDAAA;IACA,6CAAA;EACF;EACE;IACE,+BAAA;EACJ;AACF;AAEE;EAvBF;IAwBI,2BAAA;EACF;AACF;AACE;EA3BF;IA4BI,+BAAA;IACA,kBAAA;IAAA,kDAAA;EAEF;EAAE;IACE,0BAAA;EAEJ;AACF;AACE;EApCF;IAqCI,oCAAA;IACA,kBAAA;IAAA,kDAAA;EAEF;EAAE;IACE,+BAAA;EAEJ;AACF;AACE;EA7CF;IA8CE,oCAAA;IACE,gBAAA;EAEF;EAAE;IACE,+BAAA;EAEJ;AACF;AACE;EACE,6BAAA;AACJ;AAEE;EACE,gDAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAFJ;AAGI;EALF;IAMI,mBAAA;IACA,iBAAA;EAAJ;AACF;AAEI;EAVF;IAWI,eAAA;EACJ;AACF;AAEM;EADF;IAEI,kBAAA;IACA,iBAAA;EACN;AACF;AAEI;EACE,kBAAA;AAAN;AAGI;EACE,WAAA;EACA,eAAA;AADN;AAGM;EACE,SAAA;AADR;AAKI;EACE,mBAAA;EACA,kBAAA;AAHN;AAOE;EASE,WAAA;EACA,aAAA;EACF,kEAAA;EACA,oCAAA;EACE,iBAAA;AAbJ;AACI;EACE,aAAA;AACN;AAEI;EACE,aAAA;AAAN;AAUE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AARJ;AAWI;EARF;IASI,wBAAA;IACA,8BAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;EARJ;AACF;AAUI;EAhBF;IAiBI,gBAAA;IACA,kBAAA;EAPJ;AACF;AASI;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,qCAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AAWM;EACE,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AATR","sourcesContent":[".navbar {\n  display: grid;\n  /* Make left and right columns auto-sized and the middle flexible so left\n    content can grow dynamically when present. */\n  grid-template-columns: auto 1fr auto;\n  grid-auto-rows: 1;\n  align-items: center;\n  padding: 30px var(--layout-research-padding, 0); // Align with research form padding\n  $navbar: &;\n  box-shadow: 0 0px 6px 1px rgba(0,0,0,0.22);\n  z-index: 100; // Ensure it stays above sticky elements in the content area\n  position: relative; // Establish stacking context\n\n  @media (max-width: 768px) {\n    grid-template-columns: auto 1fr auto;\n    padding: 15px var(--layout-research-padding, 10px);\n    box-shadow: 0 0px 6px 1px rgba(0,0,0,0.22);\n\n    &[data-has-logo=\"false\"] {\n      grid-template-columns: 1fr auto;\n    }\n  }\n\n  @media (max-width: 576px) {\n    padding: 12px 8px 12px 10px;\n  }\n\n  @media (min-width: 768px) {\n    grid-template-columns: auto 1fr;\n    padding: 15px var(--layout-research-padding, 10px);\n\n    &[data-has-logo=\"false\"] {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  @media (min-width: 992px) {\n    grid-template-columns: auto 1fr auto;\n    padding: 15px var(--layout-research-padding, 10px);\n\n    &[data-has-logo=\"false\"] {\n      grid-template-columns: 1fr auto;\n    }\n  }\n\n  @media (min-width: 1200px) {\n  grid-template-columns: auto 1fr auto;\n    box-shadow: none;\n\n    &[data-has-logo=\"false\"] {\n      grid-template-columns: 1fr auto;\n    }\n  }\n\n  &[data-theme=\"transparent\"] {\n    background-color: transparent;\n  }\n\n  &[data-theme=\"light\"] {\n    background-color: var(--primary-color-light-500);\n  }\n\n  * + * {\n    margin-top: 0;\n  }\n\n  &__brand {\n    visibility: hidden;\n    grid-row: 1;\n    display: flex;\n    align-items: center;\n    @media (max-width: 1200px) {\n      visibility: visible;\n      padding-left: 2px;\n    }\n\n    @media (max-width: 576px) {\n      padding-left: 0;\n    }\n\n    &[data-desktop=\"true\"] {\n      @media (min-width: 1200px) { \n        visibility: hidden;\n        padding-left: 0px;\n      }\n    }\n\n    &__button {\n      margin-right: 15px;\n    }\n\n    &__logo {\n      width: 50px;\n      margin-top: 5px;\n\n      a { \n        border: 0;\n      }\n    }\n\n    &.hold {\n      visibility: visible;\n      padding-left: 30px;\n    }\n  }\n\n  &__body {\n    &:before {\n      content: none;\n    }\n\n    &:after {\n      content: none;\n    }\n\n    grid-row: 1;\n    display: grid;\n  /* inside the body, make left and right auto and middle flexible */\n  grid-template-columns: auto 1fr auto;\n    grid-auto-rows: 1;\n  }\n\n  &__end {\n    grid-row: 1;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n\n    // Keep visible on mobile but with compact styling\n    @media (max-width: 992px) {\n      display: flex !important;\n      visibility: visible !important;\n      margin-left: 8px;\n      flex-shrink: 0;\n      min-width: auto;\n    }\n\n    @media (max-width: 576px) {\n      margin-left: 2px;\n      padding-right: 2px;\n    }\n\n    &__button {\n      display:  inline-flex;\n      padding: 8px 14px;\n      border-radius: 5px;\n      background-color: var(--primary-color-500);\n      color: var(--primary-color-light-500);\n      font-family: \"Aller\";\n      font-size: 12px;\n      font-weight: 400;\n      letter-spacing: 0;\n      line-height: 15px;\n      border-bottom: 0;\n      transition: .3s;\n      $button: &;\n\n\n      &:hover {\n        transition: .3s;\n        color: var(--primary-color-light-500);\n        border-bottom: 0;\n        box-shadow: 0;\n        opacity: 0.8;\n      }\n\n      &:visited {\n        @extend #{$button};\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
